// apps/web/src/offline/NetworkService.js

import fetch from 'auth/FetchInterceptor'

const NETWORK_STATUS = {
    ONLINE: 'ONLINE',
    OFFLINE: 'OFFLINE',
}

let currentStatus =
    NETWORK_STATUS.OFFLINE

const checkApiConnection =
    async () => {
        try {
            const result =
                await Promise.race([
                    fetch({
                        url:
                            '/health',

                        method:
                            'get',

                        silentNetworkError:
                            true,

                        params: {
                            t:
                                Date.now(),
                        },
                    }),

                    new Promise(
                        (_, reject) => {
                            window.setTimeout(
                                () => {
                                    reject(
                                        new Error(
                                            'NETWORK_TIMEOUT',
                                        ),
                                    )
                                },
                                2000,
                            )
                        },
                    ),
                ])

            if (
                result?.ok !== true
            ) {
                throw new Error(
                    'INVALID_HEALTH_RESPONSE',
                )
            }

            currentStatus =
                NETWORK_STATUS.ONLINE

            return true
        } catch (error) {
            currentStatus =
                NETWORK_STATUS.OFFLINE

            return false
        }
    }

const isOnline = () =>
    currentStatus ===
    NETWORK_STATUS.ONLINE

const getStatus = () =>
    currentStatus

const NetworkService = {
    checkApiConnection,
    isOnline,
    getStatus,
}

export {
    NETWORK_STATUS,
}

export default NetworkService